import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles({
  content: {
    "& .MuiFormControl-root": {
      marginTop: "10px"
    },
    "& > span": {
      fontSize: "14px",
      lineHeight: "18px"
    }
  }
});

export default function ResultSkill({ moduleResultSkill, change }) {
  const { content } = useStyles();
  return (
    <div className={content}>
      <span>Характеристика новых профессиональных и общих компетенций</span>
      <TextField
        multiline
        rows={5}
        fullWidth
        onChange={e => change("resultSkill", e.target.value)}
        value={
          (moduleResultSkill.data && moduleResultSkill.data.resultSkill) || ""
        }
        InputLabelProps={{
          shrink: true
        }}
      />
    </div>
  );
}
